import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { ElderShellService } from '@elderbyte/ngx-starter'
import { ProcessPlan } from '../process-plan'
import { ProcessPlanDetailComponent } from '../process-plan-detail/process-plan-detail.component'

@Component({
  selector: 'app-process-plan-detail-side',
  templateUrl: './process-plan-detail-side.component.html',
  styleUrls: ['./process-plan-detail-side.component.scss'],
  imports: [ProcessPlanDetailComponent],
})
export class ProcessPlanDetailSideComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly processPlan: ProcessPlan
  private shellService = inject(ElderShellService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const route = inject(ActivatedRoute)
    this.processPlan = route.snapshot.data['processPlan']
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onClose(event: Event): void {
    this.shellService.closeSideContent()
  }
}
